<div class="text-slate-400 text-center py-8">
  <h1 class="font-bold">{{ title }}</h1>
  <div class="mb-4">
    <span class="block max-w-[400px] m-auto">{{ description }}</span>
    <span *ngIf="descriptionSecondLine" class="block max-w-[400px] m-auto">{{
      descriptionSecondLine
    }}</span>
    <span
      *ngIf="callToActionText"
      class="block underline cursor-pointer text-blue-500 mt-4"
      (click)="callToActionClick.emit()"
      >{{ callToActionText }}</span
    >
  </div>
</div>
